import {gql} from "@apollo/client";
    
export const CREATE_PROJECTS = gql`  
mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    createdById
    updatedById
    createdByName
    updatedByName
  }
}`;

export const CREATE_VENDOR_PROJECT_USER = gql`
  mutation CreateVendorProjectUser($input: CreateVendorProjectUserInput!) {
    createVendorProjectUser(input: $input) {
      message
    }
  }
`;

export const CREATE_STUDENT_SESSION_ALLOCATIONS = gql`
  mutation CreateSessionAllocations($input: CreateSessionAllocationsInput!) {
  createSessionAllocations(input: $input) {
    message
  }
}
`;

export const CREATE_LIVECLASS_PACKAGES = gql`
  mutation CreateLiveclassPackages($input: CreateLiveclassPackagesInput!) {
    createLiveclassPackages(input: $input) {
      package {
        id
        name
        batchId
        batchName
        gradeId
        gradeName
        branchId
        branchName
        sectionId
        sectionName
        academicYearId
        academicYearName
        streamId
        streamName
        projectId
        packageStudentsCount
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
    }
  }
`;

export const CREATE_NLEARN3_PACKAGE_SCHEDULE = gql`
  mutation CreateNlearn3PackageSchedule(
    $input: CreateNlearn3PackageScheduleInput!
  ) {
    createNlearn3PackageSchedule(input: $input) {
      id
      liveSessionId
      status
      scheduledDurationInMin
      scheduledParticipantsCount
      meetingTitle
      meetingSubTitle
      thumbnailUrl
      notesUrl
      recordingMetadata
      cancelledAt
      completedAt
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
`;

export const CREATE_PACKAGE_SCHEDULE = gql`
  mutation CreatePackageSchedule($input: CreatePackageScheduleInput!) {
    createPackageSchedule(input: $input) {
      id
      liveSessionId
      status
      scheduledDurationInMin
      scheduledParticipantsCount
      meetingTitle
      subjectName
      meetingSubTitle
      thumbnailUrl
      notesUrl
      metadata
      cancelledAt
      completedAt
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
`;

export const UPDATE_PACKAGE_SCHEDULE = gql`
  mutation UpdatePackageSchedule($input: UpdatePackageScheduleInput!) {
    updatePackageSchedule(input: $input) {
      message
    }
  }
`;

export const DELETE_PACKAGE_SCHEDULE = gql`
  mutation DeletePackageSchedule($input: DeletePackageScheduleInput!) {
    deletePackageSchedule(input: $input) {
      message
    }
  }
`;

export const CREATE_HOST_JOINING_LINK = gql`
  mutation CreateJoiningLink($input: ZoomSdkConfigInput!) {
    createJoiningLink(input: $input) {
      hostJoiningLink
    }
  }
`;

export const CREATE_PACKAGE_SCHEDULE_CO_HOST = gql`
  mutation CreatePackageScheduleCoHost($input: [CreatePackageScheduleCohostInput!]!) {
    createPackageScheduleCoHost(input: $input) {
      message
    }
  }
`;

export const CREATE_PACKAGE_SCHEDULE_OBSERVER = gql`
  mutation CreatePackageScheduleObserver($input: [CreatePackageScheduleObserverInput!]!) {
    createPackageScheduleObserver(input: $input) {
      message
    }
  }
`;

export const UPDATE_NLEARN3_LIVECLASS_MASTER = gql`
  mutation UpdateNlearn3LiveclassMaster($input: UpdateNlearn3LiveClassMasterInput!) {
    updateNlearn3LiveclassMaster(input: $input) {
      nlearn3LiveClassMaster {
        id
        class
        liveClassUrl
        recordedUrls
        thumbnail
        urlSource
        name
        duration
        liveDateTime
        courseDay
        batch
        subBatch
        college
        admissionNumber
        markAsDeleted
        liveClassId
        subjectName
        subject
        employee
        branch
        department
        designation
        recordedVideoMaxVisibleDate
        packageId
        packageName
        yearId
        createdAt
        updatedAt
      }
    }
  }
`;

export const CREATE_GOOGLE_WORKSPACE_USER = gql`
  mutation CreateGoogleWorkspaceUser($input: CreateGoogleWorkspaceUserInput!) {
    createGoogleWorkspaceUser(input: $input) { 
      id
      name
      email
      googleUserId
      isActive
      passwordLastChangedAt
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
`;
